'use client'

import { Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import type { ReactNode } from 'react'
import { UploadImage } from '../editar-perfil/_components/UploadImage'

interface UploadImageModalProps {
	children: ReactNode
	id: string
	setImageUrl: (imageUrl: string) => void
	isEditable: boolean
	mode: 'profile' | 'cover' | 'history'
}

export function UploadImageModal({ children, id, setImageUrl, isEditable, mode }: UploadImageModalProps) {
	const [opened, { open, close }] = useDisclosure(false)

	return (
		<>
			<div onClick={isEditable ? open : undefined} className="cursor-pointer">
				{children}
			</div>

			<Modal opened={opened} onClose={close} title="" size="lg" centered>
				<UploadImage
					id={id}
					callback={() => {
						close()
					}}
					setImageUrl={setImageUrl}
					mode={mode}
				/>
			</Modal>
		</>
	)
}
